import { capitalize } from 'vue';

import CreativeFileTagType from '@/common/enums/CreativeFileTagType.enum';
import CreativeType from '@/common/enums/CreativeType.enum';
import { IOption } from '@/common/models/Option';
import i18n from '@/vueI18n';

interface ICreativeFileTagTypeOption extends IOption {
  creativeTypes: CreativeType[];
}

class CreativeFileTagTypeOptions {
  static options(): ICreativeFileTagTypeOption[] {
    return [
      {
        value: CreativeFileTagType.IFrame,
        name: capitalize(i18n.global.t('options.creativeFileTagType.iFrame')),
        creativeTypes: [CreativeType.Banner],
      },
      {
        value: CreativeFileTagType.Javascript,
        name: capitalize(i18n.global.t('options.creativeFileTagType.javascript')),
        creativeTypes: [CreativeType.Banner],
      },
      {
        value: CreativeFileTagType.Standard,
        name: capitalize(i18n.global.t('options.creativeFileTagType.standard')),
        creativeTypes: [CreativeType.Banner],
      },
      {
        value: CreativeFileTagType.Vast20,
        name: capitalize(i18n.global.t('options.creativeFileTagType.vast20')),
        creativeTypes: [CreativeType.Video],
      },
      {
        value: CreativeFileTagType.Vast30,
        name: capitalize(i18n.global.t('options.creativeFileTagType.vast30')),
        creativeTypes: [CreativeType.Video],
      },
      {
        value: CreativeFileTagType.Vast40,
        name: capitalize(i18n.global.t('options.creativeFileTagType.vast40')),
        creativeTypes: [CreativeType.Video],
      },
    ];
  }
}

export default CreativeFileTagTypeOptions;
